import React from 'react';
import { useNavigate } from 'react-router';
import MagicButton from 'components/MagicButton/MagicButton';
import './SharedCollection.css';
import { SEOHelmet } from 'components/SEO';

const UserNotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleBrowseUsers = () => {
    navigate('/welcome');
  };

  return (
    <>
      <SEOHelmet
        title="User Not Found - TradeMagic"
        description="The user you're looking for doesn't exist on TradeMagic."
        canonical="https://trademagic.gg/404"
      />

      <div className="shared-collection-error">
      <div className="error-content">
        <div className="error-icon">🔍</div>
        <h1 className="error-title">User Not Found</h1>
        <p className="error-message">
          We couldn't find a user with this username.
        </p>
        <div className="error-action">
          <MagicButton
            label="Browse All Users"
            color="purple"
            onPress={handleBrowseUsers}
          />
        </div>
      </div>
    </div>
    </>
  );
};

export default UserNotFoundPage;
